<template>
  <div class="cart-slider">
    <Swiper
      v-cart-scroll-spy-active="{ selector: '.cart-slider__item', class: 'active' }"
      class="cart-slider__swiper"
      :modules="modules"
      :slides-per-view="3"
      :free-mode="true"
      :space-between="10"
      @swiper="onSwiper"
    >
      <SwiperSlide v-for="(group, index) in props.groups" :key="index">
        <a :href="`#subMenu${index}`" class="cart-slider__item">
          {{ getNameByLocale(group) }}
        </a>
      </SwiperSlide>
    </Swiper>

    <div class="cart-slider__prev" @mouseup="handlePrevClick" @touchend.prevent="handlePrevClick"></div>
    <div class="cart-slider__next" @mouseup="handleNextClick" @touchend.prevent="handleNextClick"></div>
  </div>
</template>

<script setup lang="ts">
  import { useSwiperStore } from '@/stores/swiper';
  import { getNameByLocale } from '@/utils';
  import { FreeMode } from 'swiper/modules';
  import 'swiper/swiper-bundle.css';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { ref } from 'vue';

  interface Props {
    groups: any[];
  }
  const props = defineProps<Props>();

  // swiper 에 사용 될 모듈
  const modules = ref([FreeMode]);
  // swiper 지정
  const groupSwiper = ref();

  /**
   * swiper 실행 시 해당 swiper option 할당
   * @param swiper
   */
  const onSwiper = (swiper: any) => {
    groupSwiper.value = swiper;
    useSwiperStore().setToppingGroupSwiper(swiper);
  };
  /**
   * 이전 메뉴 리스트로 이동
   */
  const handlePrevClick = () => {
    groupSwiper.value.slidePrev();
  };
  /**
   * 다음 메뉴 리스트로 이동
   */
  const handleNextClick = () => {
    groupSwiper.value.slideNext();
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .cart-slider {
    min-width: 0;
    position: relative;
    padding: 0 3.7313vw;
    .swiper-slide {
      text-align: center;
    }
    .cart-slider__item {
      position: relative;
      display: block;
      align-items: center;
      height: 3.7313vw;
      font-size: 1.7164vw;
      font-weight: 700;
      color: #000;
      padding: 0 0.7463vw 0.3731vw;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      &.active {
        color: var(--brand-primary);
      }
      &.active:after {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.3731vw;
        background: var(--brand-primary);
        content: '';
      }
    }
    .cart-slider__prev,
    .cart-slider__next {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 2.2388vw;
      height: 3.7313vw;
      margin-top: -0.3731vw;
    }
    .cart-slider__prev {
      left: 0;
      background: url('@/assets/images/icon-chevron-left-gray.svg') no-repeat center;
      background-size: 1.1194vw 1.9403vw;
    }
    .cart-slider__next {
      right: 0;
      background: url('@/assets/images/icon-chevron-right-gray.svg') no-repeat center;
      background-size: 1.1194vw 1.9403vw;
    }
  }
  @media (max-width: vars.$md) {
    .cart-slider {
      .cart-slider__item {
        font-size: 14px;
        height: auto;
      }
      .cart-slider__prev {
        left: 0;
        background-size: 6px 16px;
      }
      .cart-slider__next {
        right: 0;
        background-size: 6px 16px;
      }
    }
  }
</style>
